module.exports = __webpack_public_path__ + "img/KSC07678.cde91aaf.jpg";